import { useMemo } from 'react';
import type { MentionsStore } from '.';

export function useActiveMentions(store: MentionsStore) {
  return useMemo(
    () => store.state.list.filter((item) => !item.data.dismissed_at),
    [store.state.list],
  );
}

export function useRecentMentions(store: MentionsStore) {
  return useMemo(
    () =>
      [...store.state.list].sort(
        (a, b) =>
          new Date(b.data.created_at).getTime() -
          new Date(a.data.created_at).getTime(),
      ),
    [store.state.list],
  );
}
